import { aboutChips } from "@/mocks/homeContent";

export default function About() {
  return (
    <section id="about" className="w-full scroll-mt-24 bg-[#efe7d5]">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-16 md:px-6 md:py-20">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 text-[12px] font-semibold tracking-[0.24em] text-[#b3873a]">
            <span className="h-px w-5 bg-[#c8a45f]" aria-hidden="true" />
            OUR STANCE · 关于黑料舍
            <span className="h-px w-5 bg-[#c8a45f]" aria-hidden="true" />
          </span>
          <h2 className="mt-4 font-song text-[26px] font-semibold leading-tight text-[#241f18] md:text-[32px]">
            不是追着跑，而是把存货整理成册
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-[#6d6149]">
            黑料舍做的不是临时起哄，而是把散在各处的私藏存货与干货家底，按主题和时间线慢慢
            收进宝库。老料新料都能顺着索引翻到，热门爆料也帮你标好入口，让它真正成为一个
            「翻得到、看得懂、回得来」的资料库。
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-2.5">
            {aboutChips.map((c) => (
              <span
                key={c}
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-[#d8cbb1] bg-[#faf5ea] px-3.5 py-1.5 text-[12px] text-[#5d523f]"
              >
                <i className="ri-verified-badge-fill text-[12px] text-[#a1762f]" aria-hidden="true" />
                {c}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}